<div class="out" kzLib (click)="showOpts($event)">
  <div class="round">
    <img *ngIf="img_src" [src]="img_src" class="tr_img" [ngClass]="{ 'dark_mono': theme=='dark'}" (load)="onImageLoad($event)" [width]="profile_width" [height]="profile_height" [style.top.px]="profile_top" [style.left.px]="profile_left">
  </div>
  <div *ngIf="!call_id" class="open" [ngClass]="{red: bBusy}">
    <img src="assets/images/expand_white.svg" class="abs_center expand" [ngClass]="{ 'close': show_tool=='prof-opts'}">
  </div>
</div>
